import script from "./ChangeContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeContent.vue?vue&type=script&setup=true&lang=js"

import "./ChangeContent.vue?vue&type=style&index=0&id=e4420ccc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4420ccc"]])

export default __exports__